export default "__VITE_ASSET__CUxHxMLu__"